export default __webpack_public_path__ + "static/media/profile-picture-2.6d657a5c.jpg";